import { __extends } from 'tslib';
import React__default, { PureComponent } from 'react';

var i = 1.618;
var Arrow = (function (_super) {
    __extends(Arrow, _super);
    function Arrow(props) {
        var _this = _super.call(this, props) || this;
        _this._init = function () {
            var startEl = _this._findEl(_this.props.fromSelector);
            var endEl = _this._findEl(_this.props.toSelector);
            if (startEl && endEl) {
                var startPoint = _this._getPoint(startEl, _this.props.fromSide);
                var endPoint = _this._getPoint(endEl, _this.props.toSide);
                var startCurveOffset = _this._getCurveOffsets(startEl, _this.props.fromSide, startPoint, endPoint);
                var endCurveOffset = _this._getCurveOffsets(endEl, _this.props.toSide, startPoint, endPoint);
                var endLineOffset = _this._getLineOffset(_this.props.toSide);
                var arrow = _this._getArrow(endPoint, _this.props.toSide);
                if (startPoint && endPoint) {
                    _this.setState({
                        startX: startPoint.x,
                        startY: startPoint.y,
                        endX: endPoint.x,
                        endY: endPoint.y,
                        width: endPoint.x - startPoint.x,
                        height: endPoint.y - startPoint.y,
                        startCurveOffset: startCurveOffset,
                        endCurveOffset: endCurveOffset,
                        endLineOffset: endLineOffset,
                        arrow: arrow,
                    });
                }
            }
        };
        _this._getLineOffset = function (side) {
            if (side === void 0) { side = 'top'; }
            var x = 0;
            var y = 0;
            switch (side) {
                case 'top': {
                    y = _this.pointerSize;
                    return { x: x, y: y };
                }
                case 'bottom': {
                    y = -_this.pointerSize;
                    return { x: x, y: y };
                }
                case 'left': {
                    x = _this.pointerSize;
                    return { x: x, y: y };
                }
                case 'right': {
                    x = -_this.pointerSize;
                    return { x: x, y: y };
                }
                default: {
                    return { x: x, y: y };
                }
            }
        };
        _this._getArrow = function (endPoint, side) {
            if (side === void 0) { side = 'top'; }
            switch (side) {
                case 'top': {
                    return endPoint.x + "," + endPoint.y + " " + (endPoint.x - _this.tailOffset) + "," + (endPoint.y - _this.pointerSize) + "  " + (endPoint.x + _this.tailOffset) + "," + (endPoint.y - _this.pointerSize);
                }
                case 'bottom': {
                    return endPoint.x + "," + endPoint.y + " " + (endPoint.x - _this.tailOffset) + "," + (endPoint.y + _this.pointerSize) + "  " + (endPoint.x + _this.tailOffset) + "," + (endPoint.y + _this.pointerSize);
                }
                case 'left': {
                    return endPoint.x + "," + endPoint.y + " " + (endPoint.x - _this.pointerSize) + "," + (endPoint.y - _this.tailOffset) + " " + (endPoint.x - _this.pointerSize) + "," + (endPoint.y + _this.tailOffset);
                }
                case 'right': {
                    return endPoint.x + "," + endPoint.y + " " + (endPoint.x + _this.pointerSize) + "," + (endPoint.y - _this.tailOffset) + " " + (endPoint.x + _this.pointerSize) + "," + (endPoint.y + _this.tailOffset);
                }
                default: {
                    return undefined;
                }
            }
        };
        _this._findEl = function (selector) {
            return document.querySelector(selector);
        };
        _this._getPoint = function (el, side) {
            if (side === void 0) { side = 'top'; }
            var rect = el.getBoundingClientRect();
            switch (side) {
                case 'top': {
                    var x = rect.left + rect.width / 2;
                    var y = rect.top;
                    return { x: x, y: y };
                }
                case 'bottom': {
                    var x = rect.left + rect.width / 2;
                    var y = rect.top + rect.height;
                    return { x: x, y: y };
                }
                case 'left': {
                    var x = rect.left;
                    var y = rect.top + rect.height / 2;
                    return { x: x, y: y };
                }
                case 'right': {
                    var x = rect.left + rect.width;
                    var y = rect.top + rect.height / 2;
                    return { x: x, y: y };
                }
                default: {
                    return {
                        x: 0,
                        y: 0,
                    };
                }
            }
        };
        _this._getCurveOffsets = function (el, side, startPoint, endPoint) {
            var S = side ? side : 'top';
            var distance = Math.sqrt(Math.pow(endPoint.x - startPoint.x, 2) + Math.pow(endPoint.y - startPoint.y, 2));
            var curveindex = distance * 0.2;
            switch (S) {
                case 'top': {
                    return { x: 0, y: curveindex };
                }
                case 'bottom': {
                    return { x: 0, y: -curveindex };
                }
                case 'left': {
                    return { x: curveindex, y: 0 };
                }
                case 'right': {
                    return { x: -curveindex, y: 0 };
                }
                default: {
                    return { x: 0, y: 0 };
                }
            }
        };
        _this.tailOffset = _this.props.stroke * i * i;
        _this.pointerSize = _this.tailOffset * 2 * i;
        _this.state = {
            startX: 0,
            startY: 0,
            endX: 0,
            endY: 0,
            width: 0,
            height: 0,
            startCurveOffset: { x: 0, y: 0 },
            endCurveOffset: { x: 0, y: 0 },
            endLineOffset: { x: 0, y: 0 },
            arrow: undefined,
        };
        return _this;
    }
    Arrow.prototype.componentDidMount = function () {
        var _this = this;
        this._init();
        window === null || window === void 0 ? void 0 : window.addEventListener('resize', function (e) {
            _this._init();
        }, true);
        window === null || window === void 0 ? void 0 : window.addEventListener('scroll', function (e) {
            _this._init();
        }, true);
    };
    Arrow.prototype.render = function () {
        if (!window)
            return null;
        var path = "M" + this.state.startX + "," + this.state.startY + "C" + (this.state.startX - this.state.startCurveOffset.x) + "," + (this.state.startY - this.state.startCurveOffset.y) + " " + (this.state.endX - this.state.endCurveOffset.x) + "," + (this.state.endY - this.state.endCurveOffset.y) + " " + (this.state.endX - this.state.endLineOffset.x) + "," + (this.state.endY - this.state.endLineOffset.y);
        return (React__default.createElement("svg", { className: this.props.className || '', style: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                pointerEvents: 'none',
            }, width: window.innerWidth, height: window.innerHeight, viewBox: "0 0 " + window.innerWidth + " " + window.innerHeight, preserveAspectRatio: "none" },
            React__default.createElement("path", { d: path, stroke: this.props.color ? this.props.color : '#000', strokeWidth: this.props.stroke, fill: "transparent" }),
            React__default.createElement("polygon", { points: this.state.arrow, fill: this.props.color ? this.props.color : '#000' })));
    };
    return Arrow;
}(PureComponent));

export { Arrow as default };
//# sourceMappingURL=Arrow.js.map
